<smrts-dialog title="Reconciliar Lançamentos antigos" [hasFootnote]="true">

  <div class="content custom-table">
    <div class="accent-color">
      Cria uma nova conciliação trazendo os lançamentos em aberto e os lançamentos já conciliados dentro do periodo selecionado abaixo
    </div>

    <div class="inline-element periodo-row">
      <p-floatlabel variant="on">
        <p-datepicker fluid [showIcon]="true" dateFormat="dd/mm/yy" appendTo="body" [(ngModel)]="dataInicial"/>
        <label>Data Inicial</label>
      </p-floatlabel>

      
      <p-floatlabel variant="on">
        <p-datepicker fluid [showIcon]="true" dateFormat="dd/mm/yy" appendTo="body" [(ngModel)]="dataFinal"/>
        <label>Data Final</label>
      </p-floatlabel>
    </div>
  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="buscarClick()">
      Buscar
    </button>
  </div>
</smrts-dialog>